
import React from 'react'

export default ()=>{
    return <div className="footer">
        Copyright &copy; 2019 云南云逍信息技术有限公司All Right Reserved
        <a className="m-l" href="http://beian.miit.gov.cn" target="_blank">滇ICP备19002102号-1</a>
    </div>
}
